// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';

export async function getRoutes() {
  const routes = {"1":{"path":"/user","layout":false,"id":"1"},"2":{"name":"login","path":"/user/login","parentId":"1","id":"2"},"3":{"path":"/admin","name":"admin","icon":"crown","access":"canAdmin","parentId":"ant-design-pro-layout","id":"3"},"4":{"path":"/admin","redirect":"/admin/sub-page","parentId":"3","id":"4"},"5":{"path":"/admin/sub-page","name":"sub-page","parentId":"3","id":"5"},"6":{"name":"workflow.instances","icon":"table","path":"/workflow","parentId":"ant-design-pro-layout","id":"6"},"7":{"path":"/","redirect":"/workflow","parentId":"ant-design-pro-layout","id":"7"},"8":{"path":"*","layout":false,"id":"8"},"ant-design-pro-layout":{"id":"ant-design-pro-layout","path":"/","isLayout":true}} as const;
  return {
    routes,
    routeComponents: {
'1': React.lazy(() => import('./EmptyRoute')),
'2': React.lazy(() => import(/* webpackChunkName: "p__user__login__index" */'@/pages/user/login/index.tsx')),
'3': React.lazy(() => import('./EmptyRoute')),
'4': React.lazy(() => import('./EmptyRoute')),
'5': React.lazy(() => import(/* webpackChunkName: "p__Admin" */'@/pages/Admin.tsx')),
'6': React.lazy(() => import(/* webpackChunkName: "p__workflow__index" */'@/pages/workflow/index.tsx')),
'7': React.lazy(() => import('./EmptyRoute')),
'8': React.lazy(() => import(/* webpackChunkName: "p__404" */'@/pages/404.tsx')),
'ant-design-pro-layout': React.lazy(() => import(/* webpackChunkName: "t__plugin-layout__Layout" */'X:/workflow/frontend/src/.umi-production/plugin-layout/Layout.tsx')),
},
  };
}
